/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
export type IIssueAutomationRuleFragment = { __typename?: 'IssueAutomationRule' } & Pick<
  Types.IIssueAutomationRule,
  'id' | 'name' | 'ruleAction' | 'updatedAt'
> & {
    issueAutomationRuleNodes: Array<
      { __typename?: 'IssueAutomationRuleNode' } & Pick<Types.IIssueAutomationRuleNode, 'id'> & {
          parameters:
            | ({ __typename?: 'IssueAutomationRuleNodeShipmentEventParameters' } & Pick<
                Types.IIssueAutomationRuleNodeShipmentEventParameters,
                'shipmentEventFields' | 'shipmentEventOperator'
              >)
            | ({ __typename?: 'IssueAutomationRuleNodeShipmentInformationParameters' } & Pick<
                Types.IIssueAutomationRuleNodeShipmentInformationParameters,
                'shipmentInformationFields' | 'shipmentInformationOperator'
              >)
            | ({ __typename?: 'IssueAutomationRuleNodeShipmentStateParameters' } & Pick<
                Types.IIssueAutomationRuleNodeShipmentStateParameters,
                'shipmentStates'
              >)
            | ({ __typename?: 'IssueAutomationRuleNodeTimeWindowParameters' } & Pick<
                Types.IIssueAutomationRuleNodeTimeWindowParameters,
                'timeWindowSeconds' | 'timeWindowOperator' | 'timeWindowField'
              >)
        }
    >
    updatedBy: { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>
  }

export const IssueAutomationRuleFragmentDoc = gql`
  fragment IssueAutomationRule on IssueAutomationRule {
    id
    name
    ruleAction
    updatedAt
    issueAutomationRuleNodes {
      id
      parameters {
        ... on IssueAutomationRuleNodeShipmentStateParameters {
          shipmentStates
        }
        ... on IssueAutomationRuleNodeTimeWindowParameters {
          timeWindowSeconds
          timeWindowOperator
          timeWindowField
        }
        ... on IssueAutomationRuleNodeShipmentInformationParameters {
          shipmentInformationFields
          shipmentInformationOperator
        }
        ... on IssueAutomationRuleNodeShipmentEventParameters {
          shipmentEventFields
          shipmentEventOperator
        }
      }
    }
    updatedBy {
      id
      fullName
    }
  }
`
